module.exports = __webpack_public_path__ + "static/media/group53@2x.f978b639.png";